module.exports = __webpack_public_path__ + "static/img/83-3.130b132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/83-3.jpg
// module id = bQT3
// module chunks = 0